/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataPageOfGlobalSettings } from '../models/data-page-of-global-settings';
import { globalMappingSettingsAddSpacesToCamelCase } from '../fn/global-mapping-settings/global-mapping-settings-add-spaces-to-camel-case';
import { GlobalMappingSettingsAddSpacesToCamelCase$Params } from '../fn/global-mapping-settings/global-mapping-settings-add-spaces-to-camel-case';
import { globalMappingSettingsCreate } from '../fn/global-mapping-settings/global-mapping-settings-create';
import { GlobalMappingSettingsCreate$Params } from '../fn/global-mapping-settings/global-mapping-settings-create';
import { globalMappingSettingsDelete } from '../fn/global-mapping-settings/global-mapping-settings-delete';
import { GlobalMappingSettingsDelete$Params } from '../fn/global-mapping-settings/global-mapping-settings-delete';
import { globalMappingSettingsDelete2 } from '../fn/global-mapping-settings/global-mapping-settings-delete-2';
import { GlobalMappingSettingsDelete2$Params } from '../fn/global-mapping-settings/global-mapping-settings-delete-2';
import { globalMappingSettingsFetch } from '../fn/global-mapping-settings/global-mapping-settings-fetch';
import { GlobalMappingSettingsFetch$Params } from '../fn/global-mapping-settings/global-mapping-settings-fetch';
import { globalMappingSettingsGetDropdownListGlobalSettingType } from '../fn/global-mapping-settings/global-mapping-settings-get-dropdown-list-global-setting-type';
import { GlobalMappingSettingsGetDropdownListGlobalSettingType$Params } from '../fn/global-mapping-settings/global-mapping-settings-get-dropdown-list-global-setting-type';
import { globalMappingSettingsGetDropdownListTypeSetting } from '../fn/global-mapping-settings/global-mapping-settings-get-dropdown-list-type-setting';
import { GlobalMappingSettingsGetDropdownListTypeSetting$Params } from '../fn/global-mapping-settings/global-mapping-settings-get-dropdown-list-type-setting';
import { globalMappingSettingsGetDropdownListUiPreferences } from '../fn/global-mapping-settings/global-mapping-settings-get-dropdown-list-ui-preferences';
import { GlobalMappingSettingsGetDropdownListUiPreferences$Params } from '../fn/global-mapping-settings/global-mapping-settings-get-dropdown-list-ui-preferences';
import { globalMappingSettingsGlobalSettingList } from '../fn/global-mapping-settings/global-mapping-settings-global-setting-list';
import { GlobalMappingSettingsGlobalSettingList$Params } from '../fn/global-mapping-settings/global-mapping-settings-global-setting-list';
import { globalMappingSettingsList } from '../fn/global-mapping-settings/global-mapping-settings-list';
import { GlobalMappingSettingsList$Params } from '../fn/global-mapping-settings/global-mapping-settings-list';
import { globalMappingSettingsPut } from '../fn/global-mapping-settings/global-mapping-settings-put';
import { GlobalMappingSettingsPut$Params } from '../fn/global-mapping-settings/global-mapping-settings-put';
import { globalMappingSettingsSearch } from '../fn/global-mapping-settings/global-mapping-settings-search';
import { GlobalMappingSettingsSearch$Params } from '../fn/global-mapping-settings/global-mapping-settings-search';
import { GlobalSettingList } from '../models/global-setting-list';
import { GlobalSettings } from '../models/global-settings';
import { KeyValue } from '../models/key-value';

@Injectable({ providedIn: 'root' })
export class GlobalMappingSettingsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `globalMappingSettingsGlobalSettingList()` */
  static readonly GlobalMappingSettingsGlobalSettingListPath = '/GlobalMappingSetting/globalSettingList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalMappingSettingsGlobalSettingList()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsGlobalSettingList$Response(params?: GlobalMappingSettingsGlobalSettingList$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalSettingList>> {
    return globalMappingSettingsGlobalSettingList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalMappingSettingsGlobalSettingList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsGlobalSettingList(params?: GlobalMappingSettingsGlobalSettingList$Params, context?: HttpContext): Observable<GlobalSettingList> {
    return this.globalMappingSettingsGlobalSettingList$Response(params, context).pipe(
      map((r: StrictHttpResponse<GlobalSettingList>): GlobalSettingList => r.body)
    );
  }

  /** Path part for operation `globalMappingSettingsGetDropdownListGlobalSettingType()` */
  static readonly GlobalMappingSettingsGetDropdownListGlobalSettingTypePath = '/api/GlobalMappingSettings/ddlListGlobalSettingType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalMappingSettingsGetDropdownListGlobalSettingType()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsGetDropdownListGlobalSettingType$Response(params?: GlobalMappingSettingsGetDropdownListGlobalSettingType$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KeyValue>>> {
    return globalMappingSettingsGetDropdownListGlobalSettingType(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalMappingSettingsGetDropdownListGlobalSettingType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsGetDropdownListGlobalSettingType(params?: GlobalMappingSettingsGetDropdownListGlobalSettingType$Params, context?: HttpContext): Observable<Array<KeyValue>> {
    return this.globalMappingSettingsGetDropdownListGlobalSettingType$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<KeyValue>>): Array<KeyValue> => r.body)
    );
  }

  /** Path part for operation `globalMappingSettingsGetDropdownListUiPreferences()` */
  static readonly GlobalMappingSettingsGetDropdownListUiPreferencesPath = '/api/GlobalMappingSettings/ddlistUIPreferences';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalMappingSettingsGetDropdownListUiPreferences()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsGetDropdownListUiPreferences$Response(params?: GlobalMappingSettingsGetDropdownListUiPreferences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KeyValue>>> {
    return globalMappingSettingsGetDropdownListUiPreferences(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalMappingSettingsGetDropdownListUiPreferences$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsGetDropdownListUiPreferences(params?: GlobalMappingSettingsGetDropdownListUiPreferences$Params, context?: HttpContext): Observable<Array<KeyValue>> {
    return this.globalMappingSettingsGetDropdownListUiPreferences$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<KeyValue>>): Array<KeyValue> => r.body)
    );
  }

  /** Path part for operation `globalMappingSettingsGetDropdownListTypeSetting()` */
  static readonly GlobalMappingSettingsGetDropdownListTypeSettingPath = '/api/GlobalMappingSettings/ddlistType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalMappingSettingsGetDropdownListTypeSetting()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsGetDropdownListTypeSetting$Response(params?: GlobalMappingSettingsGetDropdownListTypeSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KeyValue>>> {
    return globalMappingSettingsGetDropdownListTypeSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalMappingSettingsGetDropdownListTypeSetting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsGetDropdownListTypeSetting(params?: GlobalMappingSettingsGetDropdownListTypeSetting$Params, context?: HttpContext): Observable<Array<KeyValue>> {
    return this.globalMappingSettingsGetDropdownListTypeSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<KeyValue>>): Array<KeyValue> => r.body)
    );
  }

  /** Path part for operation `globalMappingSettingsAddSpacesToCamelCase()` */
  static readonly GlobalMappingSettingsAddSpacesToCamelCasePath = '/api/GlobalMappingSettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalMappingSettingsAddSpacesToCamelCase()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsAddSpacesToCamelCase$Response(params?: GlobalMappingSettingsAddSpacesToCamelCase$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return globalMappingSettingsAddSpacesToCamelCase(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalMappingSettingsAddSpacesToCamelCase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsAddSpacesToCamelCase(params?: GlobalMappingSettingsAddSpacesToCamelCase$Params, context?: HttpContext): Observable<string> {
    return this.globalMappingSettingsAddSpacesToCamelCase$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `globalMappingSettingsCreate()` */
  static readonly GlobalMappingSettingsCreatePath = '/GlobalMappingSetting/createmappingsetting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalMappingSettingsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  globalMappingSettingsCreate$Response(params: GlobalMappingSettingsCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return globalMappingSettingsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalMappingSettingsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  globalMappingSettingsCreate(params: GlobalMappingSettingsCreate$Params, context?: HttpContext): Observable<Blob> {
    return this.globalMappingSettingsCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `globalMappingSettingsFetch()` */
  static readonly GlobalMappingSettingsFetchPath = '/globalsettings/fetch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalMappingSettingsFetch()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsFetch$Response(params?: GlobalMappingSettingsFetch$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalSettings>> {
    return globalMappingSettingsFetch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalMappingSettingsFetch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsFetch(params?: GlobalMappingSettingsFetch$Params, context?: HttpContext): Observable<GlobalSettings> {
    return this.globalMappingSettingsFetch$Response(params, context).pipe(
      map((r: StrictHttpResponse<GlobalSettings>): GlobalSettings => r.body)
    );
  }

  /** Path part for operation `globalMappingSettingsPut()` */
  static readonly GlobalMappingSettingsPutPath = '/globalmappingSetting/updatemappingsetting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalMappingSettingsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  globalMappingSettingsPut$Response(params: GlobalMappingSettingsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return globalMappingSettingsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalMappingSettingsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  globalMappingSettingsPut(params: GlobalMappingSettingsPut$Params, context?: HttpContext): Observable<Blob> {
    return this.globalMappingSettingsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `globalMappingSettingsList()` */
  static readonly GlobalMappingSettingsListPath = '/globalsettings/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalMappingSettingsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsList$Response(params?: GlobalMappingSettingsList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GlobalSettings>>> {
    return globalMappingSettingsList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalMappingSettingsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsList(params?: GlobalMappingSettingsList$Params, context?: HttpContext): Observable<Array<GlobalSettings>> {
    return this.globalMappingSettingsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GlobalSettings>>): Array<GlobalSettings> => r.body)
    );
  }

  /** Path part for operation `globalMappingSettingsSearch()` */
  static readonly GlobalMappingSettingsSearchPath = '/globalsettings/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalMappingSettingsSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsSearch$Response(params?: GlobalMappingSettingsSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfGlobalSettings>> {
    return globalMappingSettingsSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalMappingSettingsSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsSearch(params?: GlobalMappingSettingsSearch$Params, context?: HttpContext): Observable<DataPageOfGlobalSettings> {
    return this.globalMappingSettingsSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfGlobalSettings>): DataPageOfGlobalSettings => r.body)
    );
  }

  /** Path part for operation `globalMappingSettingsDelete()` */
  static readonly GlobalMappingSettingsDeletePath = '/api/GlobalMappingSettings/globalsettings/delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalMappingSettingsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsDelete$Response(params?: GlobalMappingSettingsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return globalMappingSettingsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalMappingSettingsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsDelete(params?: GlobalMappingSettingsDelete$Params, context?: HttpContext): Observable<Blob> {
    return this.globalMappingSettingsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `globalMappingSettingsDelete2()` */
  static readonly GlobalMappingSettingsDelete2Path = '/api/GlobalMappingSettings/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalMappingSettingsDelete2()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsDelete2$Response(params: GlobalMappingSettingsDelete2$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return globalMappingSettingsDelete2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalMappingSettingsDelete2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalMappingSettingsDelete2(params: GlobalMappingSettingsDelete2$Params, context?: HttpContext): Observable<Blob> {
    return this.globalMappingSettingsDelete2$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
